import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IModalState {
  isOpen: boolean;
  onTop: boolean;
}

export type ModalKeys =
  | "configureModal"
  | "projectModal"
  | "conflictDetailModal"
  | "websocketProcessModal"
  | "commitModal"
  | "aiAnalyzerTableModal"
  | "commitHistoryModal"
  | "adminPanelChangeItemModal"
  | "adminPanelAddFeatureModal"
  | "loadingStagingNodesModal"
  | "scriptSettingsModal"
  | "dragAndDropAnyModal"
  | "dragAndDropParentModal"
  | "dragAndDropGenericModal"
  | "aiDataExtractorUploadModal"
  ;

type IInitialState = Record<ModalKeys, IModalState>;

const initialState: IInitialState = {
  configureModal: { isOpen: false, onTop: false },
  projectModal: { isOpen: false, onTop: false },
  conflictDetailModal: { isOpen: false, onTop: false },
  websocketProcessModal: { isOpen: false, onTop: true },
  commitModal: { isOpen: false, onTop: false },
  aiAnalyzerTableModal: { isOpen: false, onTop: false },
  commitHistoryModal: { isOpen: false, onTop: false },
  adminPanelChangeItemModal: { isOpen: false, onTop: false },
  adminPanelAddFeatureModal: { isOpen: false, onTop: false },
  loadingStagingNodesModal: { isOpen: false, onTop: false },
  scriptSettingsModal: { isOpen: false, onTop: false },
  dragAndDropAnyModal: { isOpen: false, onTop: false },
  dragAndDropParentModal: { isOpen: false, onTop: false },
  dragAndDropGenericModal: { isOpen: false, onTop: false },
  aiDataExtractorUploadModal: { isOpen: false, onTop: false }
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalKeys>) => {
      state[action.payload] = { isOpen: true, onTop: state[action.payload].onTop };
    },
    closeModal: (state, action: PayloadAction<ModalKeys>) => {
      state[action.payload] = { isOpen: false, onTop: state[action.payload].onTop };
    },
  },
});

export default modalSlice.reducer;
export const { openModal, closeModal } = modalSlice.actions;
